import { createZodFormResolver, lt, useFormControls, useSafeUrlState } from '@mews/framework';
import { Button, IconName, Stack } from '@optimus-web/core';
import { FilterSidebar } from '@mews/b2b-ui';
import { DateIntervalFields } from '@mews-commander/form';
import {
    filtersSchema,
    FiltersValueKey,
    LedgerActivityReportFilterValues,
    defaultLedgerActivityReportFilterValues,
} from '../schema';

interface LedgerActivityReportFiltersProps {
    open: boolean;
    toggleSidebar: () => void;
    setFilterValues: (filters: LedgerActivityReportFilterValues) => void;
}
export const LedgerActivityReportFilters = ({
    open,
    toggleSidebar,
    setFilterValues,
}: LedgerActivityReportFiltersProps) => {
    const [urlState] = useSafeUrlState(filtersSchema);

    const handleSubmit = (values: LedgerActivityReportFilterValues) => {
        setFilterValues(values);
    };

    const { reset: resetFields, renderFormContent } = useFormControls({
        id: 'ledger-activity-report-filter',
        defaultValues: urlState ?? defaultLedgerActivityReportFilterValues,
        mode: 'onSubmit',
        onSubmit: handleSubmit,
        resolver: createZodFormResolver(filtersSchema),
    });

    const reset = () => {
        setFilterValues(defaultLedgerActivityReportFilterValues);
        resetFields(defaultLedgerActivityReportFilterValues);
    };

    return renderFormContent(
        <FilterSidebar
            primaryButton={{
                label: lt('ApplyFilters'),
                type: 'submit',
            }}
            actions={
                <Stack alignment="start" fill>
                    <Button icon={IconName.Refresh} onClick={reset} type="button" variant="ghost" size="medium">
                        {lt('ResetFilters')}
                    </Button>
                </Stack>
            }
            hideOffset="300"
            show={open}
            title={lt('Filter')}
            toggle={toggleSidebar}
        >
            <Stack spacing="300" vertical>
                <DateIntervalFields
                    startDateProps={{
                        name: FiltersValueKey.startDate,
                        label: lt('StartDate'),
                    }}
                    endDateProps={{
                        name: FiltersValueKey.endDate,
                        label: lt('EndDate'),
                    }}
                    mode="iso"
                    size="medium"
                />
            </Stack>
        </FilterSidebar>
    );
};
